import React, { useContext, useEffect, useState } from 'react';
import { KiteLoader, KitePagination, KiteTable } from '@kite/react-kite';
import { getAllNotifications } from '../../apiCalls/NotificationService';
import { IAllNotifications, INotification } from '../../utils/notifications';
import { formatDate } from '../../utils/utilFunctions';
import { AnalyticsContext } from '../../analytics/AnalyticsContextProvider';
import './SentNotificationTable.scss';

const SentNotificationTable = () => {
  const [notificationData, setNotificationData] = useState<INotification[]>();
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [analytics] = useContext(AnalyticsContext);

  const columnData = [
    {
      label: 'Send Date',
      key: 'createdAt',
    },
    {
      label: 'Notification Title',
      key: 'title',
    },
    {
      label: 'Message',
      key: 'message',
    },
    {
      label: 'Sent By',
      key: 'createdBy',
    },
  ];

  useEffect(() => {
    setLoading(true);
    const controller = new AbortController();
    const signal = controller.signal;
    getAllNotifications(currentPage, signal, analytics)
      .then((res) => {
        const response = res as IAllNotifications;
        setTotalPages(response?.totalPages ?? 1);
        setCurrentPage(response?.pageable.pageNumber ?? 0);
        setNotificationData(
          response?.content.map((notification) => ({
            ...notification,
            createdAt: formatDate(notification.createdAt),
          }))
        );
      })
      .catch((err) => {
        console.log(err);
        setErrorState(true);
      })
      .finally(() => {
        setLoading(false);
      });

    return () => {
      controller.abort();
    };
  }, [currentPage]);

  return (
    <div className="sent-notification-container">
      {loading && <KiteLoader />}
      {errorState && (
        <KiteLoader
          status="failure"
          loaderTitle="Something went wrong, please try again later"
        />
      )}
      {!loading && !errorState && (
        <>
          <KiteTable
            columns={columnData}
            tableData={notificationData}
            useStripes
            className="sent-notification-table"
          />
          <KitePagination
            totalPages={totalPages}
            currentPage={currentPage + 1}
            onNextPage={() => setCurrentPage(currentPage + 1)}
            onPrevPage={() => setCurrentPage(currentPage - 1)}
            onPageSelect={(number) => {
              setCurrentPage(number - 1);
            }}
          />
        </>
      )}
    </div>
  );
};

export default SentNotificationTable;
